import { useParams } from 'react-router-dom'

import { useGetByTenantAccountAndAccountSourceAccountIdentifierQuery } from '@/api/rtk-api'
import { Card, LoadingPresentationalTable, PresentationalTable, Tabs } from '@/components/core-v2'
import { TENANT } from '@/const'
import { displayPercentage } from '@/utilities/number'
import { sentenceCase } from '@/utilities/string'

import { getFeeTypeName } from '../trade-fees-breakdown-tab/utils'

const HEADER_ROW = ['Type', 'Name', 'Calculated on', 'Frequency', 'Amount']
const ROW_OPTIONS = [{}, {}, {}, {}, { align: 'right' }]

export const TradeFeesRatesTab = () => {
  const { source, tradeId } = useParams()
  const { data, isLoading } = useGetByTenantAccountAndAccountSourceAccountIdentifierQuery({
    tenant: TENANT,
    accountIdentifier: tradeId,
    accountSource: source
  })
  if (isLoading)
    return (
      <Tabs.Panel value="rates">
        <Card.Wrapper>
          <LoadingPresentationalTable rowCount={8} rowOptions={ROW_OPTIONS} />
        </Card.Wrapper>
      </Tabs.Panel>
    )

  const rows = ['note', 'portfolio', 'strategy']
    .map(type =>
      data.account[type].fees.map(fee => [
        sentenceCase(type),
        getFeeTypeName(fee.feeType),
        sentenceCase(fee.feeBasis),
        sentenceCase(fee.feeDeductionFrequency),
        `${displayPercentage(fee.feeRate, 2)} p.a.`
      ])
    )
    .flat()

  return (
    <Tabs.Panel value="rates">
      <Card.Wrapper>
        <PresentationalTable headerRow={HEADER_ROW} rowOptions={ROW_OPTIONS} rows={rows} />
      </Card.Wrapper>
    </Tabs.Panel>
  )
}
